var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_-_person",
    "data-name": "ico - person",
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6679",
    "data-name": "Rect\\xE1ngulo 6679",
    width: 36,
    height: 36,
    transform: "translate(0 -4)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-person-6733745",
    transform: "translate(-4.091 3.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15559",
    "data-name": "Grupo 15559",
    transform: "translate(14.933 1.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sustracci\\xF3n_9",
    "data-name": "Sustracci\\xF3n 9",
    d: "M5530.67-936.794h-7v-4.457a.5.5,0,0,0-.5-.5.5.5,0,0,0-.5.5v4.457h-2.513v-6.349a4.042,4.042,0,0,1,.414-1.545,2.8,2.8,0,0,1,2.677-1.545h8.135a3.094,3.094,0,0,1,3.09,3.09v6.348h-2.8v-4.457a.5.5,0,0,0-.5-.5.5.5,0,0,0-.5.5v4.457Z",
    transform: "translate(-5520.158 955.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9678",
    "data-name": "Trazado 9678",
    d: "M26.995,5.639a4.145,4.145,0,1,1-4.145-4.145,4.146,4.146,0,0,1,4.145,4.145",
    transform: "translate(-15.691 -1.493)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerson);
export default __webpack_public_path__ + "static/media/icon-person.071a0aa7bc010adca799ab2461e06700.svg";
export { ForwardRef as ReactComponent };